import { Box, IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import { useState, MouseEvent } from "react";
import { Download } from "@mui/icons-material";
import { MRT_ColumnDef, MRT_TableInstance } from "material-react-table";
import { UtilCsv } from "../util/UtilCsv";
import { useTranslation } from "react-i18next";
import { Z_INDEX } from "../styles/zIndex";

interface Props {
	prefix: string;
	data: any[];
	columns: MRT_ColumnDef<any>[];
	table: MRT_TableInstance<any>;
}

const ExportMenuButton = ({ prefix, data, columns, table }: Props) => {
	const { t } = useTranslation();
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

	const open = Boolean(anchorEl);
	const dataLabels = Object.keys(data[0] || {});

	const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<Box sx={{ display: data.length !== 0 ? 'block' : 'none' }}>
			<Tooltip title={t("common:ui.buttons.quickDownload")}>
				<IconButton onClick={handleClick} color="warning" aria-label={t("common:ui.buttons.quickDownload")}>
					<Download />
				</IconButton>
			</Tooltip>
			<Menu
				id="basic-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				sx={{ zIndex: Z_INDEX.dialogPopover }}
				slotProps={{
					list: {
						'aria-labelledby': 'basic-button',
					},
				}}
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
			>
				<MenuItem
					disabled={table.getPrePaginationRowModel().rows.length === 0}
					onClick={() => {
						UtilCsv.handleExportMRTRows(table.getPrePaginationRowModel().rows, columns, prefix, dataLabels);
						handleClose();
					}}>{t("common:export.menu.allRows")}</MenuItem>
				<MenuItem
					disabled={table.getFilteredRowModel().rows.length === 0}
					onClick={() => {
						UtilCsv.handleExportMRTRows(table.getFilteredRowModel().rows, columns, prefix, dataLabels);
						handleClose();
					}}>{t("common:export.menu.filteredRows")}</MenuItem>
				<MenuItem
					disabled={table.getRowModel().rows.length === 0}
					onClick={() => {
						UtilCsv.handleExportMRTRows(table.getRowModel().rows, columns, prefix, dataLabels);
						handleClose();
					}}>{t("common:export.menu.page")}</MenuItem>
				<MenuItem
					disabled={
						!table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
					}
					onClick={() => {
						UtilCsv.handleExportMRTRows(table.getSelectedRowModel().rows, columns, prefix, dataLabels);
						handleClose();
					}}>{t("common:export.menu.selectedRows")}</MenuItem>
			</Menu>
		</Box>
	);
};

export default ExportMenuButton;
